import { FETCH_POSTS, FETCH_POST } from './types';

export const fetchPosts = () => dispatch => {
    fetch('https://sinomost.kz/API/blog/')
    .then(res => res.json())
    .then(posts => dispatch({
        type: FETCH_POSTS,
        payload: posts
    }));
};

export const fetchPost = (id) => dispatch => {
    fetch(`https://sinomost.kz/API/blog/${id}/`)
    .then(res => res.json())
    .then(post => dispatch({
        type: FETCH_POST,
        payload: post
    }));
};


// export const createPost = (postData) => dispatch => {
//     fetch('https://sinomost.kz/API/blog/', {
//         method: 'POST',
//         headers: {
//             'content-type': 'application/json'
//         },
//         body: JSON.stringify(postData)
//     })
//     .then(res => res.json())
//     .then(post => dispatch({
//         type: NEW_POST,
//         payload: post
//     }));
// };
//
// export const deletePost = (id) => dispatch => {
//     fetch(`https://sinomost.kz/API/blog/${id}/`, {
//         method: 'DELETE'
//     })
//     .then(res => res.json())
//     .then(post => dispatch({
//         type: DELETE_POST,
//         payload: id
//     }));
// };
